import React, {
  useState,
  useEffect,
  useRef,
  createContext,
  useContext,
} from "react";
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
  Divider,
  OutlinedInput,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import {
  TrendingUp,
  CreditCard,
  Message,
  AccountBalanceWallet,
  Public,
  Receipt,
  Settings,
  Download,
  Add,
  Visibility,
  CalendarToday,
  AttachMoney,
  ArrowUpward,
  Info,
  Co2Sharp,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useAuth } from "../../hooks/AuthProvider";
import { AI_REPORT_TOKEN_USAGE, DAILY_USAGE_ANALYTICS_ENDPOINT, GET_WALLET_DETAILS } from "../../config/urls";
import { GET_WALLET_MONTHLY_SPEND } from "../../config/urls";
import { WHATSAPP_BILLING_LIST_ENDPOINT } from "../../config/urls";
import { GET_TENANT_SUBCRIPTION } from "../../config/urls";
import { GET_WALLET_INITIATE_CASHFREE_ENDPOINT } from "../../config/urls";
import { GET_WALLET_TRANSACTIONS } from "../../config/urls";
import { GET_INVOICES_ENDPOINT } from "../../config/urls";
import { GET_TENANT_DETAILS } from "../../config/urls";
import { format } from "date-fns";
import { load } from "@cashfreepayments/cashfree-js";
import { CASHFREE_MODE } from "../../config/environment";
import dayjs from "dayjs";
import {ReactComponent as BlueReloadIcon } from "../../assets/images/icons/billing_overview/reload-svg-icon.svg"
import {ReactComponent as LoadWalletIcon } from "../../assets/images/icons/billing_overview/load_wallet.svg"
import {ReactComponent as BlueWalletIcon } from "../../assets/images/icons/billing_overview/blue-wallet.svg"
import {ReactComponent as BlueEyeIcon } from "../../assets/images/icons/billing_overview/eye.svg"
import {ReactComponent as DownloadIcon } from "../../assets/images/icons/billing_overview/download.svg"
import { BillingDashboardContext } from "./BillingDashboard"; // We'll create this context
import { displayName } from "react-quill";
import ButtonTwo from "../../common/dashboard-button";
import ButtonOne from "../../common/normal-button";
import { ColorsConstants } from "../../cssUtils/constants";
import typography from "../../cssUtils/typography";
import { formatDateOnly, formatWithTzLabel } from "../../utils/dateUtils";

export default function OverviewTab(props) {
  const { getValidToken } = useAuth();
  const tenant = localStorage.getItem("tenant");
  const [walletData, setWalletData] = useState(null);
  const [monthlySpend, setMonthlySpend] = useState(0);
  const [totalMessages, setTotalMessages] = useState(0);
  const [subscription, setSubscription] = useState(null);
  const [showAddFundsModal, setShowAddFundsModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [aiStats, setAiStats] = useState({})
  const[loading, setLoading] = useState(false)
  const[error, setError] = useState("")
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [platformSubscriptionData, setPlatformSubscriptionData] = useState({
    planName: "",
    renewalDate: "",
    startDate: "",
    paymentAmount: "N/A",
    billingCycleLabel: "",
    title: "Platform Subscription",
    subtitle: "This shows your current plan, billing cycle, and subscription validity."
  })
  const [submitting, setSubmitting] = useState(false);
  const [recentActivity, setRecentActivity] = useState({
    lastTopUp: null,
    lastInvoice: null,
  });
  const [hasUnpaidInvoice, setHasUnpaidInvoice] = useState(false);
  const [billingCurrency, setBillingCurrency] = useState("INR"); // Default to INR

  const cashfreeRef = useRef(null);

  // Function to get currency symbol
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case "USD":
        return "$";
      case "EUR":
        return "€";
      case "GBP":
        return "£";
      case "INR":
        return "₹";
      case "AED":
        return "د.إ";
      default:
        return "₹"; // Default to Indian Rupee symbol
    }
  };

  // Function to format currency with proper symbol
  const formatCurrency = (value) => {
    const currencySymbol = getCurrencySymbol(billingCurrency);
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: billingCurrency,
      minimumFractionDigits: 2,
    }).format(value).replace(/[A-Z]{3}/, currencySymbol);
  };

  // Simple format for display without full currency formatting
  const formatCurrencySimple = (value) => {
    const currencySymbol = getCurrencySymbol(billingCurrency);
    return `${currencySymbol}${value ? parseFloat(value).toFixed(2) : '0.00'}`;
  };
  
  const fetchAIData = async () => {
    setLoading(true);
    setError(null);

    const now = new Date();

    const startDate = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .split("T")[0];

    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      .toISOString()
      .split("T")[0];

    try {
      const token = await getValidToken();

      const response = await fetch(
        `${AI_REPORT_TOKEN_USAGE}?from_date=${startDate}&to_date=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch token usage");

      const json = await response.json();
      if (!json.success) throw new Error("API returned failure");

      const data = json.data;

      setAiStats({
        total_tokens: data.total_tokens,
        total_cost: data.total_cost,
        average_tokens_per_request: data.average_tokens_per_request,
      });

    } catch (error) {
      console.log(error.message);
    }
  };


  useEffect(() => {
    fetchWalletDetails();
    fetchMonthlySpend();
    getCurrentPlanDetails();
    fetchTenantDetails().then((currency) => fetchSubscription(currency));
    fetchRecentActivity();
    fetchAIData()
    // Initialize Cashfree SDK
    const initializeSDK = async () => {
      if (typeof window === "undefined") return;

      try {
        const cf = await load({ mode: CASHFREE_MODE });
        if (!cf) {
          console.error("❌ SDK load() returned null");
          return;
        }
        console.log("✅ SDK loaded", cf);
        cashfreeRef.current = cf;
      } catch (e) {
        console.error("❌ Failed to load SDK:", e);
      }
    };

    initializeSDK();
  }, []);

  const apiRequest = async (url, options = {}) => {
    const token = await getValidToken();
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Tenant-ID": localStorage.getItem("tenant"),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  };

  const fetchWalletDetails = async () => {
    try {
      const data = await apiRequest(GET_WALLET_DETAILS);
      setWalletData(data);
      console.log("Wallet Details:", data);
    } catch (error) {
      console.error("Error fetching wallet details:", error);
    }
  };

  const fetchTenantDetails = async () => {
    try {
      const data = await apiRequest(GET_TENANT_DETAILS);
      console.log("Tenant Details:", data);
      const currency = data?.results?.[0]?.billing_currency;
      if (currency) {
        setBillingCurrency(currency);
        return currency;
      }
    } catch (error) {
      console.error("Error fetching tenant details:", error);
    }
    return "INR"; // fallback
  }

  const fetchMonthlySpend = async () => {
    try {
      const data = await apiRequest(GET_WALLET_MONTHLY_SPEND);
      console.log("Monthly spend fetched:", data);
      setMonthlySpend(data?.current_month_spend || 0);
      setTotalMessages(data?.total_messages)
    } catch (error) {
      console.error("Error fetching monthly spend:", error);
    }
  };

  

  const formatPlanName = (planName) => {
    const map = {
      whatsapp_lite: "WhatsApp Lite",
      whatsapp_advanced: "WhatsApp Advanced",
      whatsapp_advanced_custom_solution: "WhatsApp Custom",
    };
    if (!planName) return "";
    return (
      map[planName] ||
      planName
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    );
  };

  const fetchSubscription = async (currency = billingCurrency) => {
    try {
      const data = await apiRequest(GET_TENANT_SUBCRIPTION);

      const subscription = data;
      if (!subscription) return;

      const formattedPlanName = formatPlanName(subscription?.plan?.name);
      setSubscription(formattedPlanName);

      // subscription.price is the plan cost; subscription.billing_cycle is the cycle
      let paymentAmount = "N/A";
      let billingCycleLabel = "";

      if (subscription.status !== "trial" && subscription?.price) {
        const currSym = getCurrencySymbol(currency);
        paymentAmount = `${currSym}${parseFloat(subscription.price).toLocaleString("en-IN")}`;

        const cycle = subscription?.billing_cycle?.toLowerCase();
        if (cycle === "quarterly") billingCycleLabel = "/qtr";
        else if (cycle === "yearly") billingCycleLabel = "/yr";
        else if (cycle === "monthly") billingCycleLabel = "/mo";
      }

      setPlatformSubscriptionData((prev) => ({
        ...prev,
        planName: formattedPlanName,
        startDate: subscription.start_date,
        renewalDate: subscription.end_date,
        paymentAmount,
        billingCycleLabel,
      }));

    } catch (error) {
      console.error("Error fetching subscription:", error.message);
    }
  };

  console.log(platformSubscriptionData, "platform subs data")

    const getCurrentPlanDetails = () => {
      try{
        const plan = localStorage.getItem("plan");
        const formattedPlanName = formatPlanName(plan);
        setSubscription(formattedPlanName)
      }catch(error){
        console.error("Error fetching current plan details:", error.message);
      }
  };

  const fetchRecentActivity = async () => {
    try {
      // Fetch latest wallet transactions
      const transactionsResponse = await apiRequest(
        `${GET_WALLET_TRANSACTIONS}?page=1&page_size=10`
      );
      const transactions = transactionsResponse.results || [];

      // Find the latest deposit transaction
      const latestDeposit = transactions
        .filter(
          (tx) =>
            tx.type_display?.toLowerCase() === "deposit" &&
            tx.status_display?.toLowerCase() === "completed"
        )
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

      // Fetch latest invoices
      const invoicesResponse = await apiRequest(GET_INVOICES_ENDPOINT);
      setHasUnpaidInvoice(invoicesResponse.unpaid_invoice || false);
      const invoices = invoicesResponse.results || [];

      // Find the latest invoice
      const latestInvoice = invoices.sort(
        (a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)
      )[0];

      setRecentActivity({
        lastTopUp: latestDeposit,
        lastInvoice: latestInvoice,
      });
    } catch (error) {
      console.error("Error fetching recent activity:", error);
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = dayjs(dateString);
    const now = dayjs();
    const diffInHours = now.diff(date, "hour");

    if (diffInHours < 24) {
      if (diffInHours < 1) {
        const minutes = now.diff(date, "minute");
        return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
      }
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    } else {
      return formatWithTzLabel(dateString, "MMM D, YYYY [at] h:mm A");
    }
  };

  const handleAddFunds = () => {
    setShowAddFundsModal(true);
  };

  const handleAmountSubmit = () => {
    if (amount && parseFloat(amount) > 0) {
      setShowAddFundsModal(false);
      setShowConfirmModal(true);
    }
  };

  const handleConfirm = async () => {
    try {
      setSubmitting(true);
      const tenant = localStorage.getItem("tenant");
      const token = await getValidToken();

      const res = await fetch(`${GET_WALLET_INITIATE_CASHFREE_ENDPOINT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Tenant-ID": tenant,
        },
        body: JSON.stringify({ amount: parseInt(amount, 10) }),
      });

      const data = await res.json();
      console.log("Initiate Cashfree response:", data);
      console.log("Cashfree ref:", cashfreeRef.current);
      if (data.payment_session_id && cashfreeRef.current) {
        try {
          cashfreeRef.current.checkout({
            paymentSessionId: data.payment_session_id,
            redirectTarget: "_self",
          });
        } catch (err) {
          console.error("Cashfree checkout error:", err);
          showSnackbar("Failed to open payment window", "error");
        }
      } else {
        showSnackbar(
          data.error || data.amount || "Failed to initiate payment.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      showSnackbar("Something went wrong. Please try again.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setShowAddFundsModal(false);
    setShowConfirmModal(false);
    setAmount("");
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Add this function to your OverviewTab component
  const downloadLatestInvoice = async () => {
    try {
      const invoicesResponse = await apiRequest(GET_INVOICES_ENDPOINT);
      const invoices = invoicesResponse.results || [];

      if (invoices.length === 0) {
        showSnackbar("No invoices found", "info");
        return;
      }

      // Find the latest invoice
      const latestInvoice = invoices.sort(
        (a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)
      )[0];

      // Download the invoice
      const tenantId = localStorage.getItem("tenant");
      const token = await getValidToken();

      const response = await fetch(
        `${GET_INVOICES_ENDPOINT}${latestInvoice.id}/generate-pdf/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `Bearer ${token}`,
            "X-Tenant-ID": tenantId,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download invoice");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${latestInvoice.invoice_number}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showSnackbar("Latest invoice downloaded successfully", "success");
    } catch (error) {
      console.error("Error downloading latest invoice:", error);
      showSnackbar("Failed to download invoice", "error");
    }
  };


  const currencySymbol = getCurrencySymbol(billingCurrency);


  return (
    <Box sx={{ px: 3, py:5, backgroundColor: '#F7F7F7' }}>

      {hasUnpaidInvoice && (
        <Alert
          severity="error"
          sx={{
            mb: 3,
            alignItems: "center",
            "& .MuiAlert-message": { flex: "unset" },
            "& .MuiAlert-action": { paddingTop: 0, marginLeft: "auto" },
          }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => props.onNavigate && props.onNavigate("billing_invoices")}
            >
              View Invoices
            </Button>
          }
        >
          You have an unpaid invoice. Please clear it to avoid service interruption.
        </Alert>
      )}

      {/* PLatform Subscription */}
      <Box sx={{ mb: 4}}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
          <Box sx={{ display: "flex", flexDirection: "column", }}>
            <Typography sx={{ color: "#0F1729", ...typography.h1 }}>{platformSubscriptionData.title}</Typography>
            <Typography sx={{ color: "#737373", ...typography.bodyLarge }}>{platformSubscriptionData.subtitle}</Typography>
          </Box>
          <Box>
            <ButtonTwo
              sx={{
                borderColor: "#1976D2",
                color: "#1976D2",
                "&:hover": {
                  borderColor: "#1976D2",
                },
              }}
              startIcon={<BlueReloadIcon />}
              onClick={() => props.onNavigate("billing_subscription")}
            >
              Setup Recurring
            </ButtonTwo>
          </Box>
        </Box>

         <Box
            sx={{
              background: "#fff",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Grid container>

              {/* Plan */}
              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Your Plan
                </Typography>

                <Typography sx={{ ...typography.h2 }}>
                  {platformSubscriptionData.planName}
                </Typography>

              </Grid>

              {/* Payment */}
              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Payment Amount
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {platformSubscriptionData.paymentAmount}
                  {platformSubscriptionData.billingCycleLabel && (
                    <Typography component="span" sx={{ ...typography.bodyLarge, color: "#888" }}>
                      {platformSubscriptionData.billingCycleLabel}
                    </Typography>
                  )}
                </Typography>

              </Grid>

              {/* Due Date */}
              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Start Date
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {formatDateOnly(platformSubscriptionData.startDate)}
                </Typography>

                {/* <Typography sx={{ fontSize: 12, color: "#888" }}>
                  149.0% delivery rate
                </Typography> */}
              </Grid>

              {/* Expiry */}
              <Grid item xs={12} md={3} sx={{ p: 3 }}>
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  End Date
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {formatDateOnly(platformSubscriptionData.renewalDate)}
                </Typography>

                {/* <Typography sx={{ fontSize: 12, color: "#888" }}>
                  156.2% read rate
                </Typography> */}
              </Grid>

            </Grid>
          </Box>
      </Box>
      {/* Monthly Messaging Usage */}
      <Box sx={{ mb: 4}}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
          <Box sx={{ display: "flex", flexDirection: "column", }}>
            <Typography sx={{ color: "#0F1729", ...typography.h1 }}>Monthly Messaging Usage</Typography>
            <Typography sx={{ color: "#737373", fontSize: "14px", fontWeight: 400 }}>This shows your message usage, invoice, and wallet balance.</Typography>
          </Box>
          <Box>
            <ButtonOne
              sx={{
                borderColor: "#1976D2",
                color: "#ffffff",
                "&:hover": {
                  borderColor: "#1976D2",
                },
              }}
              onClick={handleAddFunds}
              startIcon={<LoadWalletIcon />}
            >
              Load Wallet
            </ButtonOne>
          </Box>
        </Box>

         <Box
            sx={{
              background: "#fff",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Grid container>

              {/* Plan */}
              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Last Month Invoice 
                </Typography>

                <Typography sx={{ ...typography.h2 }}>
                  {platformSubscriptionData.planName}
                </Typography>

              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Current Month Usage
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {formatCurrencySimple(monthlySpend)}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Total Messages sent
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {totalMessages?.toLocaleString() || 0}
                </Typography>
              </Grid>

              <Grid item xs={12} md={3} sx={{ p: 3 }}>
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Wallet Balance
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                    {formatCurrencySimple(walletData?.balance)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
      </Box>






      <Box sx={{ mb: 4}}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
          <Box sx={{ display: "flex", flexDirection: "column", }}>
            <Typography sx={{ color: "#0F1729", ...typography.h1 }}>AI Credits</Typography>
            <Typography sx={{ color: "#737373", fontSize: "14px", fontWeight: 400 }}>This shows your AI credit usage, cost, and remaining balance.</Typography>
          </Box>
          <Box>
            <ButtonOne
              sx={{
                borderColor: "#1976D2",
                color: "#ffffff",
                "&:hover": {
                  borderColor: "#1976D2",
                },
              }}
              startIcon={<LoadWalletIcon />}
            >
              Load Wallet
            </ButtonOne>
          </Box>
        </Box>

         <Box
            sx={{
              background: "#fff",
              borderRadius: "12px",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                 Total Cost
                </Typography>

                <Typography sx={{ ...typography.h2 }}>
                  {aiStats?.total_cost}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Token Usage
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {aiStats?.total_tokens}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                sx={{ p: 3, borderRight: "1px solid #E0E0E0" }}
              >
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Avg Tokens / Request
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {aiStats?.average_tokens_per_request}
                </Typography>
              </Grid>

              <Grid item xs={12} md={3} sx={{ p: 3 }}>
                <Typography sx={{ ...typography.bodyLarge, color: "#8A8A8A", mb: 1 }}>
                  Wallet Balance
                </Typography>

                <Typography sx={{ ...typography.h1 }}>
                  {formatCurrencySimple(walletData?.balance)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
      </Box>


      {/* Stats Cards - Row 2 */}
      

      {/* Quick Actions and Recent Activity */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography variant="h6" sx={{ mb: 2, ...typography.h1 }}>
                Quick Actions
              </Typography>
              <Grid item xs={12} md={12} wrap="wrap">
                <Grid container spacing={2}>
                  
                  <Grid item xs={6} onClick={handleAddFunds}>
                    <Box sx={{ p: 2, border: "1px solid #F7F7F7", borderRadius: 2, py: 3, display: "flex", flexDirection: "column", justifyItems: "center", alignItems: "center", backgroundColor: "#f7f7f7" }}>
                      <BlueWalletIcon />
                      <Typography sx={{ mt: 1, ...typography.h2, fontWeight: 500,  color: `${ColorsConstants.primaryBlue100}` }}>
                        Top Up Messaging Wallet
                      </Typography> 
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Box sx={{ p: 2, border: "1px solid #F7F7F7", borderRadius: 2, py: 3, display: "flex", flexDirection: "column", justifyItems: "center", alignItems: "center", backgroundColor: "#f7f7f7" }}>
                      <BlueWalletIcon />
                      <Typography sx={{ mt: 1, ...typography.h2, fontWeight: 500,  color: `${ColorsConstants.primaryBlue100}` }}>
                        Top Up AI Credits Wallet
                      </Typography> 
                    </Box>
                  </Grid>

                  <Grid item xs={6} onClick={downloadLatestInvoice}>
                   <Box  sx={{ p: 2, border: "1px solid #F7F7F7", borderRadius: 2, py: 3, display: "flex", flexDirection: "column", justifyItems: "center", alignItems: "center", backgroundColor: "#f7f7f7" }}>
                      <DownloadIcon />
                      <Typography sx={{ mt: 1, ...typography.h2, fontWeight: 500,  color: `${ColorsConstants.primaryBlue100}` }}>
                        Download Latest Invoice
                      </Typography> 
                    </Box>
                  </Grid>

                  <Grid item xs={6} 
                    
                  >
                    <Box onClick={() => props.onNavigate("billing_rate_card")} sx={{ p: 2, border: "1px solid #F7F7F7", borderRadius: 2, py: 3, display: "flex", flexDirection: "column", justifyItems: "center", alignItems: "center", backgroundColor: "#f7f7f7" }}>
                      <BlueEyeIcon />
                      <Typography sx={{ mt: 1, ...typography.h2, fontWeight: 500,  color: `${ColorsConstants.primaryBlue100}` } }>
                        View Rate Card
                      </Typography> 
                    </Box>
                  </Grid>

                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography variant="h6" gutterBottom>
                Recent Activity
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {recentActivity.lastTopUp ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: 1.5,
                      bgcolor: "grey.50",
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        bgcolor: "success.main",
                        borderRadius: "50%",
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx= {{...typography.bodyText}}>
                        Wallet topped up
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatCurrencySimple(recentActivity.lastTopUp.amount)} •{" "}
                        {formatDateTime(recentActivity.lastTopUp.created_at)}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: 1.5,
                      bgcolor: "grey.50",
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        bgcolor: "success.main",
                        borderRadius: "50%",
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{...typography.bodyText}}>
                        No recent wallet top-ups
                      </Typography>
                    </Box>
                  </Box>
                )}

                {recentActivity.lastInvoice ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: 1.5,
                      bgcolor: "grey.50",
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        bgcolor: "primary.main",
                        borderRadius: "50%",
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{...typography.bodyText}}>
                        {recentActivity.lastInvoice.status_display === "Paid"
                          ? "Invoice paid"
                          : "Invoice generated"}
                      </Typography>
                      <Typography sx={{...typography.bodySmall}} variant="caption" color="text.secondary">
                        {recentActivity.lastInvoice.invoice_number} •{" "}
                        {formatCurrencySimple(recentActivity.lastInvoice.total_amount)} •{" "}
                        {recentActivity.lastInvoice.status_display}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: 1.5,
                      bgcolor: "grey.50",
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        bgcolor: "primary.main",
                        borderRadius: "50%",
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ ...typography.bodyText}}>
                        No recent invoices
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Add Funds Modal */}
      <Dialog
        open={showAddFundsModal}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Add Funds
          <IconButton onClick={handleCancel} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Amount to Add"
            type="number"
            fullWidth
            variant="outlined"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{currencySymbol}</InputAdornment>
              ),
            }}
            sx={{ mt: 2 }}
            helperText="Enter the amount you want to add to your wallet"
          />
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleCancel} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleAmountSubmit}
            variant="contained"
            disabled={!amount || parseFloat(amount) <= 0}
            sx={{ ml: 2 }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Modal */}
      <Dialog
        open={showConfirmModal}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Confirm Transaction
          <IconButton onClick={handleCancel} size="small" disabled={submitting}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Are you sure you want to add the following amount to your wallet?
          </Typography>
          <Card sx={{ bgcolor: "#f8f9fa" }}>
            <CardContent>
              <Typography variant="subtitle2" color="text.secondary">
                Amount to Add
              </Typography>
              <Typography
                variant="h4"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                {amount && `${currencySymbol}${parseFloat(amount).toLocaleString("en-IN")}`}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Payment Method: Bank Transfer
              </Typography>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={handleCancel}
            variant="outlined"
            fullWidth
            disabled={submitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            fullWidth
            disabled={submitting}
            sx={{
              ml: 2,
              bgcolor: "#2e7d32",
              "&:hover": { bgcolor: "#1b5e20" },
            }}
          >
            {submitting ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Processing...
              </>
            ) : (
              "Confirm & Add Funds"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
